import HttpRequest from '@/config/axios.config'
import { useQuery } from 'react-query'

type CompanySettingShowModules = Record<string, unknown> | null

export function hasCompanyModule(
  companySettingModules: CompanySettingShowModules,
  moduleName: string
) {
  if (!companySettingModules) return false

  return Object.prototype.hasOwnProperty.call(companySettingModules, moduleName)
}

export function hasProductModule(
  companySettingModules: CompanySettingShowModules
) {
  return hasCompanyModule(companySettingModules, 'product')
}

export function useCompanySettingShowModules(
  userId?: string,
  options?: { cacheTime?: number }
) {
  const query = useQuery(
    ['company_setting_show_modules', userId],
    async () => {
      const response: any = await HttpRequest.get(`/company-settings`, {
        params: { name: 'show_modules' },
      })

      return (response?.data?.data[0]?.value ||
        null) as CompanySettingShowModules
    },
    {
      cacheTime: options?.cacheTime,
      enabled: Boolean(userId),
    }
  )

  return {
    ...query,
    shouldShowProductModule: hasProductModule(query.data),
  }
}
